// extracted by mini-css-extract-plugin
export default {"notes-tile":"Notes_notes-tile__febRh"};